import React, { Fragment } from 'react';
import { Paper, Typography, Link } from '@mui/material';
import TermsAndConditionsPDF from '../../../components/Layout/TermsAndConditionsPage/TermsAndConditions.pdf';

const Banner = ({ termsAndConditions }) => {
  return (
    <Fragment>
      {termsAndConditions ? (
        <Link href='/payments' style={{ cursor: 'pointer' }}>
          <Paper
            sx={{
              padding: '0.3rem',
              display: 'flex',
              backgroundColor: 'primary.main',
            }}
            square
            elevation={0}>
            <Typography
              variant='subtitle2'
              sx={{
                textAlign: 'center',
                flexGrow: '1',
                color: 'white',
              }}>
              Join The 100 Club. Be part of Singapore's leading mastermind community for founders. »
            </Typography>
          </Paper>
        </Link>
      ) : (
        <Link href='/payments' style={{ cursor: 'pointer' }}>
          <Paper
            sx={{
              padding: '0.3rem',
              display: 'flex',
              backgroundColor: 'primary.main',
            }}
            square
            elevation={0}>
            <Typography
              variant='subtitle2'
              sx={{
                textAlign: 'center',
                flexGrow: '1',
                color: 'white',
              }}>
              Our membership <button style={{ textDecoration: "underline" }} onClick={() => window.open(TermsAndConditionsPDF, '_blank')}>Terms and Conditions</button> have been updated.
            </Typography>
          </Paper>
        </Link>
      )}
    </Fragment>
  );
};

export default Banner;
